<script>
'use strict';

const _debounce = require('lodash/debounce');
const bestSellerTag = 'strategist hall of fame';

module.exports = {
  name: 'ProductFilters',
  data() {
    return {
      step: 5,
    };
  },
  created() {
    this.debouncedApplyFilters = _debounce(() => {
      this.$store.dispatch('applyFilters');
    }, 300);
  },
  computed: {
    isStickyOnMobile() {
      return this.$store.state.isStickyOnMobile;
    },
    productFilters() {
      return this.$store.state.productFilters;
    },
    price() {
      return this.productFilters.price;
    },
    priceInit() {
      return this.productFilters.priceInit;
    },
    tags() {
      return this.productFilters.tags;
    },
    onSale() {
      return this.productFilters.onSale;
    },
    // Fall back to the bounds if min/max haven't been set yet (null on init)
    displayMin() {
      if (this.price.min) return this.price.min;
      if (this.priceInit.min) return this.priceInit.min;

      return 0;
    },
    displayMax() {
      if (this.price.max) return this.price.max;
      if (this.priceInit.max) return this.priceInit.max;

      return 0;
    },
    minPercent() {
      const range = this.priceInit.max - this.priceInit.min;

      if (!range) return 0;

      return ((this.displayMin - this.priceInit.min) / range) * 100;
    },
    maxPercent() {
      const range = this.priceInit.max - this.priceInit.min;

      if (!range) return 100;

      return ((this.displayMax - this.priceInit.min) / range) * 100;
    },
    isBestSellerActive() {
      return this.tags.includes(bestSellerTag);
    },
    loading() {
      return this.$store.state.loading;
    },
    showPriceRange() {
      return this.$store.state.showPriceRange;
    },
  },
  methods: {
    setShowPriceRange() {
      this.$store.commit('togglePriceRange');
    },
    onMinInput(event) {
      // Clamp: min handle can't cross max handle. Reset the DOM value so the
      // thumb snaps back visually when the boundary is hit.
      const clamped = Math.min(event.target.valueAsNumber, this.displayMax);

      event.target.value = clamped;
      this.$store.commit('updatePriceMin', clamped);
    },
    onMaxInput(event) {
      // Clamp: max handle can't cross min handle. Reset the DOM value so the
      // thumb snaps back visually when the boundary is hit.
      const clamped = Math.max(event.target.valueAsNumber, this.displayMin);

      event.target.value = clamped;
      this.$store.commit('updatePriceMax', clamped);
    },
    setBestSeller() {
      const tags = this.isBestSellerActive
        ? this.tags.filter((t) => t !== bestSellerTag)
        : [...this.tags, bestSellerTag];
      this.$store.commit('updateTags', tags);
      this.$store.dispatch('applyFilters');
    },
    setIsonSale() {
      const onSale = !this.onSale;
      this.$store.commit('updateOnSale', onSale);
      this.$store.dispatch('applyFilters');
    },
    applyPriceFilter() {
      this.debouncedApplyFilters();
    },
    /**
     * Clears the current price range filter by committing a mutation
     * to toggle the price range state and dispatching an action to
     * reset filters and submit a new search.
     */
    clearPriceFilter() {
      this.$store.commit('togglePriceRange');
      this.$store.dispatch('clearFiltersAndSubmitSearch');
    },
  },
};
</script>

<template>
  <div
    class="product-filters"
    :class="{
      'is-sticky': isStickyOnMobile,
      'box-shadow-underline': isStickyOnMobile,
    }"
  >
    <div class="pills">
      <div class="pill" :class="{ active: onSale }" @click="setIsonSale">
        On Sale
      </div>
      <div
        class="pill"
        :class="{ active: isBestSellerActive }"
        @click="setBestSeller"
      >
        Best Seller
      </div>
      <div
        class="pill pill-price"
        :class="{ active: showPriceRange }"
        @click="setShowPriceRange"
      >
        Price
      </div>
    </div>
    <div class="price-range" v-show="showPriceRange">
      <div class="price-range-slider-wrapper">
        <div class="price-range-labels">
          <span class="price-range-label"> Min {{ '$' + displayMin }} </span>
          <span class="price-range-label"> {{ '$' + displayMax }} Max </span>
        </div>
        <div class="price-range-slider">
          <span class="price-range-cap price-range-cap-left" />

          <div class="price-range-track">
            <div
              class="price-range-fill"
              :style="{
                left: minPercent + '%',
                right: 100 - maxPercent + '%',
              }"
            ></div>
          </div>

          <input
            type="range"
            class="price-range-input"
            :min="priceInit.min"
            :max="priceInit.max"
            :step="step"
            :value="displayMin"
            @input="onMinInput($event)"
            name="price-range-min"
          />
          <input
            type="range"
            class="price-range-input"
            :min="priceInit.min"
            :max="priceInit.max"
            :step="step"
            :value="displayMax"
            @input="onMaxInput($event)"
            name="price-range-max"
          />

          <span class="price-range-cap price-range-cap-right" />
        </div>
      </div>
      <div class="price-range-apply">
        <div class="apply-button" @click="applyPriceFilter">Apply</div>
        <div class="apply-button" @click="clearPriceFilter">Clear</div>
      </div>
    </div>
  </div>
</template>
